<template lang="pug">
  section.materials.container
    .row
      .col-md-4
        // SEARCHFIELD
        .form-group
          .input-group
            input.form-control(:placeholder="localization.Search_Placeholder" v-model="searchQuery" @change="search")
            i.eva.eva-search-outline
          .clear-all-filters(v-show="this.activeFacetsValues.length")
            span.clear-filters(:title="localization.Clear_All_Filters" @click="clearFacetFilters()") {{ localization.Clear_All_Filters }}
        // SEARCHFIELD END
        // PRODUCTTREE START
        section.product-facets
          // Active State: is-active
          template(v-for="facet in facets")
            a.product-facets__category(href="#" :class="{'is-active': isFacetActive(facet)}" :title="facet.name" @click.prevent="toggleFacet(facet, $event)")
              | {{ facet.name }}
              span.product-facets__badge {{ facet.values.filter(facetValue => !facetValue.noValueFacet).length }}
              span.clear-filters.clear-facet-filters(v-show="hasActiveFacetFilters(facet)" @click.stop.prevent="clearFacetFilters(facet)") {{ getClearActiveFiltersText(facet) }}
            .product-facets__category-items()
              .product-facets__category-inner
                .product-facets__item(v-for="facetValue in facet.values")
                  template()
                    input(type="checkbox" v-model="activeFacetsValuesKeys" :value="getFacetValueKey(facetValue)" @click.stop="toggleFacetValue(facetValue)")
                    label(:class="{'is-uppercase': facet.solrField === 'filetype_s'}" @click="toggleFacetValue(facetValue)")
                      span.title {{ facetValue.title }}
                      span.product-facets__badge {{ facetValue.count }}
        // PRODUCTTREE END
      .col-md-8
        // DROPDOWNS
        .materials-controls
          .materials-controls__start
            span.materials-controls__label {{ totalResults }}
            img(v-if="loading && loadingIsTakingTooLong" src="../../static/loading.svg")
          .materials-controls__end
            .dropdown(data-dropable)
              a.has-icon(href="#" @click.prevent)
                i.eva.eva-options-2-outline
                | {{ pagination.pageSize }}
              ul.dropdown-menu
                li.dropdown-menu__item(v-for="pageSize in pagination.pageSizes")
                  a(href="#", @click.prevent="setPageSize(pageSize)") {{ pageSize }}
            .dropdown(data-dropable)
              a.has-icon(href="#" @click.prevent)
                i.eva.eva-options-outline
                |  {{ localization.Sorting }}
              ul.dropdown-menu
                li.dropdown-menu__item(:class="{'is-active': sorting.orderBy === 'score'}")
                  a(href="#" @click.prevent="setSorting('score')") {{ localization.Relevance }}
                li.dropdown-menu__item(:class="{'is-active': sorting.orderBy === 'modified_dt'}")
                  a(href="#" @click.prevent="setSorting('modified_dt')") {{ localization.Uploaded }}
                li.dropdown-menu__item(:class="{'is-active': sorting.orderBy === 'captured_dt'}")
                  a(href="#" @click.prevent="setSorting('captured_dt')") {{ localization.Capture_Date }}
                li.dropdown-menu__item(:class="{'is-active': sorting.orderBy === 'name_s'}")
                  a(href="#" @click.prevent="setSorting('name_s')") {{ localization.Asset_Name }}
                li.dropdown-menu__item(:class="{'is-active': sorting.orderBy === 'size_in_mb_f'}")
                  a(href="#" @click.prevent="setSorting('size_in_mb_f')") {{ localization.File_Size }}
                li.dropdown-menu__item
                  hr
                li.dropdown-menu__item(:class="{'is-active': sorting.orderAscending}")
                  a(href="#" @click.prevent="setAscendingSortOrder") {{ localization.Sort_Ascending }}
                li.dropdown-menu__item(:class="{'is-active': !sorting.orderAscending}")
                  a(href="#" @click.prevent="setDescendingSortOrder") {{ localization.Sort_Descending }}
            .dropdown
              a.has-icon(href="#" @click.prevent="gridView = !gridView")
                i.eva.eva-grid-outline(v-if="!gridView")
                i.eva.eva-list-outline(v-if="gridView")
                | {{ localization.View }}

        // END:DROPDOWNS
        .alert.alert-info(v-if="!hasResults") {{ localization.No_Results }}
        .materials-result(:class="{'is-block': gridView}")
          .materials-result__item(:class="{'is-active': isAssetActive(asset)}" v-for="asset in assets")
            .materials-result__presentation
              .materials-result__col
                .materials-result__image(v-if="asset.AssetThumbnail" :style="`background-image: url(${asset.AssetThumbnail})`")
                img.materials-result__image(v-else src="../../static/asset.png")
              .materials-result__col
                .materials__result-headline
                  h2(v-html="asset.Name")
                ul.materials__definition
                  li.materials__definition-item
                    label {{ localization.Asset_Type }}
                    p  {{ asset.AssetTypes instanceof Array ? asset.AssetTypes.join(', ') : '' }}
                  template(v-if="!gridView")
                    li.materials__definition-item
                      label {{ localization.Uploaded }}
                      p {{ getDate(asset.Modified) }}
                    li.materials__definition-item
                      label {{ localization.Capture_Date }}
                      p {{ getDate(asset.Captured) }}
                    li.materials__definition-item
                      label {{ localization.File_Size }}
                      p {{ asset.SizeInMb }} MB
            .materials__item-details
              div
                ul.materials__definition
                  li.materials__definition-item
                    label {{ localization.Expiration_Date }}
                    p {{ getDate(asset.ExpirationDate)}}
                  template(v-if="gridView")
                    li.materials__definition-item
                      label {{ localization.Uploaded }}
                      p {{ getDate(asset.Modified) }}
                    li.materials__definition-item
                      label {{ localization.Capture_Date }}
                      p {{ getDate(asset.Captured) }}
                    li.materials__definition-item
                      label {{ localization.File_Size }}
                      p {{ asset.SizeInMb }} MB
                  li.materials__definition-item
                    label {{ localization.Dimensions }}
                    p(v-if="asset.Width && asset.Height") {{ asset.Width }} x {{ asset.Height }} px
                    p(v-else) -
                  li.materials__definition-item
                    label {{ localization.Color_Space }}
                    p {{ asset.ColorSpace || "-" }}
                  li.materials__definition-item
                    label {{ localization.File_Type }}
                    p.is-uppercase {{ asset.FileType || '-' }}
                  li.materials__definition-item
                    label {{ localization.Product_Name }}
                    p {{ getProductName(asset) }}
                  li.materials__definition-item
                    label {{ localization.Asset_Language }}
                    p {{ getProductLanguage(asset) }}
                  li.materials__definition-item.is-fullwidth(v-if="asset.Description ")
                    label {{ localization.Description }}
                    p(v-html="asset.Description")
                  li.materials__definition-item.is-fullwidth(v-if="asset.Keywords && asset.Keywords.length")
                    label {{ localization.Keywords }}
                    p(v-html="asset.Keywords.join(', ')")
                  li.materials__definition-item.is-fullwidth(v-if="asset.ContentHighlight")
                    label {{ localization.Content_Highlight }}
                    p(v-html="asset.ContentHighlight")
            .materials-toolbox
              .materials-toolbox__start
                div
                  a.has-icon(href="#" :title="getAssetDetailsToggleText(asset)" @click.prevent="toggleAssetDetails(asset)")
                    i.eva.eva-arrow-ios-downward-outline
                    | {{ getAssetDetailsToggleText(asset) }}
              .materials-toolbox__end
                a.has-icon.popover.copy-asset-url(:href="getAssetDownloadLink(asset)" :title="localization.Copy_As_Link" @click.prevent :data-title="localization.Link_Copied")
                  i.eva.eva-link
                  span {{ localization.Copy_As_Link }}
                a.has-icon(:href="getAssetDownloadLink(asset)" :title="localization.Download" target="_blank")
                  i.eva.eva-download-outline
                  span {{ localization.Download }}
        .text-center
          .v-pagination(v-if="hasResults" is='uib-pagination' v-model='pagination.model' :total-items='pagination.totalResults' :max-size="10" :items-per-page="pagination.pageSize" @change="search" :boundary-links='true' previous-text='‹' next-text='›' first-text='«' last-text='»')
</template>

<script>
import axios from 'axios'
import Clipboard from 'clipboard'
import Scrollbar from 'smooth-scrollbar'
import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll'
import queryString from 'query-string'

Scrollbar.use(OverscrollPlugin)

export default {
  name: 'marketing-materials',

  props: {
    model: {
      type: Object,
      required: true
    },
    localization: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      loadingIsTakingTooLong: false,
      gridView: true,
      searchQuery: undefined,
      lastSearchQuery: undefined,
      assets: undefined,
      facets: [],
      activeFacets: [],
      activeFacetsValues: [],
      activeAssets: [],
      pagination: {
        model: {
          currentPage: 1
        },
        pageSize: 10,
        pageSizes: [10, 20, 30, 50],
        totalResults: undefined
      },
      sorting: {
        sortMenuIsActive: false,
        orderBy: 'modified_dt'
      }
    }
  },

  computed: {
    hasResults() {
      return !!(this.assets && this.assets.length)
    },

    activeFacetsValuesKeys() {
      return this.activeFacetsValues.map(this.getFacetValueKey)
    },

    searchFilters() {
      return this.activeFacetsValues.reduce((accumulator, facetValue) => {
        const values = accumulator[facetValue.solrField] || []

        values.push(facetValue.noValueFacet ? '' : facetValue.title)
        accumulator[facetValue.solrField] = values

        return accumulator
      }, {})
    },

    totalResults() {
      return this.getLocalizedNumberText(this.pagination.totalResults, this.localization.Total_Results, `${this.pagination.totalResults} results(s)`)
    }
  },

  created() {
    const initialFilters = queryString.parse(window.location.hash),
      initialFiltersParsed = Object.entries(initialFilters),
      searchFilter = initialFiltersParsed.find(([, value]) => value === null)

    initialFiltersParsed
      .filter(([key, value]) => key !== '' && value !== null)
      .forEach(([key, value]) =>
        (value || '').split(',').forEach(title => {
          this.activeFacetsValues.push({
            noValueFacet: false,
            solrField: key,
            title: title
          })
        })
      )

    if (searchFilter && searchFilter[0].length) {
      this.searchQuery = this.lastSearchQuery = searchFilter[0]
    }

    if (!initialFiltersParsed.length) {
      this.initDefaultResults()
    } else {
      this.search()
    }

    this.$nextTick(() => {
      this.allowCopyAssetsUrlsToClipboard()
    })
  },

  updated() {
    this.allowCopyAssetsUrlsToClipboard()
  },

  methods: {
    initDefaultResults() {
      const defaultSlot = this.$slots.default[0].children[0],
        defaultResultsJSON = defaultSlot.text

      this.setAssetsFromSearchResults(JSON.parse(defaultResultsJSON))
    },

    setAssetsFromSearchResults(searchResults) {
      this.assets = searchResults.Results
      this.pagination.model.currentPage = searchResults.Page + 1
      this.pagination.totalResults = searchResults.TotalResults

      const spotFacets = {}
      this.model.Facets.forEach(facet => (spotFacets[facet.Solr_Field] = facet))

      this.facets = Object.entries(searchResults.Facets).map(([solrField, values]) => ({
        solrField,
        name: this.model.Facets.find(modelFacet => modelFacet.Solr_Field === solrField).Name,
        values: values
          .map(facetValue => ({ solrField, noValueFacet: facetValue.Key === '', title: facetValue.Key || 'No Value', count: facetValue.Value }))
          .filter(facetValue => facetValue.count > 0)
          .map(facetValue => {
            const spotFacetSettings = spotFacets[facetValue.solrField]

            let sortOrder = facetValue.count

            if (facetValue.noValueFacet) {
              sortOrder = Number.MIN_SAFE_INTEGER
            } else if (spotFacetSettings.Sort_By === 'Override') {
              const overrideIndex = spotFacetSettings.Override_Sort.indexOf(facetValue.title)

              if (overrideIndex > -1) {
                sortOrder = 99999 - overrideIndex
              }
            }

            return {
              facetValue,
              sortOrder
            }
          })
          .sort((a, b) => b.sortOrder - a.sortOrder)
          .map(_ => _.facetValue)
      }))
    },

    allowCopyAssetsUrlsToClipboard() {
      if (this.clipboard) {
        this.clipboard.destroy()
      }

      this.clipboard = new Clipboard('.copy-asset-url', {
        text: link => link.getAttribute('href')
      })

      this.clipboard.on('success', e => {
        const el = e.trigger
        el.classList.add('is-visible')
        setTimeout(() => el.classList.remove('is-visible'), 2000)
      })
    },

    search() {
      if (this.lastSearchQuery !== this.searchQuery) {
        this.activeFacets = []
        this.sorting.orderBy = 'score'
        this.sorting.orderAscending = false
      }

      const searchRequest = {
        Device: this.model.Device,
        ItemId: this.model.ItemId,
        SpotId: this.model.SpotId,
        Query: this.searchQuery,
        Page: this.lastSearchQuery === this.searchQuery ? this.pagination.model.currentPage - 1 : 0,
        PageSize: this.pagination.pageSize,
        Facets: this.model.Facets.map(facet => facet.Solr_Field),
        Filters: this.searchFilters,
        OrderBy: this.sorting.orderBy,
        OrderDirection: this.sorting.orderAscending ? 'ASC' : 'DESC'
      }

      this.lastSearchQuery = this.searchQuery

      // cancel previous request, if any
      this.axiosRequestCancelToken && this.axiosRequestCancelToken.cancel()
      this.axiosRequestCancelToken = axios.CancelToken.source()

      this.loading = true

      const loadingIsTakingTooLongTimeoutId = setTimeout(() => (this.loadingIsTakingTooLong = true), 500)

      axios
        .post('/api/marketing-materials/search', searchRequest, { cancelToken: this.axiosRequestCancelToken.token })
        .then(response => response.data)
        .then(searchResults => this.highlightSearchResults(searchResults))
        .then(searchResults => this.setAssetsFromSearchResults(searchResults))
        .catch(e => {
          if (axios.isCancel(e)) {
            window.console.log('Search request has been cancelled')
          }
        })
        .then(() => {
          clearTimeout(loadingIsTakingTooLongTimeoutId)
          this.loading = this.loadingIsTakingTooLong = false
        })

      this.displaySearchInAddressBar()
    },

    highlightSearchResults(searchResults) {
      if (searchResults.Highlights) {
        const results = searchResults.Results

        Object.entries(searchResults.Highlights).forEach(([assetId, highlights]) => {
          const asset = results.find(asset => asset.Id === assetId)

          Object.entries(highlights).forEach(([solrField, values]) => {
            switch (solrField) {
              case 'name_t':
                asset.Name = values[0] || asset.Name
                break

              case 'description_t':
                asset.Description = values[0] || asset.Description
                break

              case 'keywords_tm':
                asset.Keywords = (asset.Keywords || []).map(keyword => (values[0] === `<em>${keyword}</em>` ? values[0] : keyword))
                break

              case 'content_t':
                asset.ContentHighlight = values[0]
                break
            }
          })
        })
      }

      return searchResults
    },

    getDate(dateString) {
      return dateString ? new Date(dateString).toLocaleDateString() : '-'
    },

    isFacetActive(facet) {
      return this.activeFacets.indexOf(facet.solrField) > -1
    },

    isAssetActive(asset) {
      return this.activeAssets.indexOf(asset) > -1
    },

    getAssetDetailsToggleText(asset) {
        return this.isAssetActive(asset) ? this.localization.Hide_Details : this.localization.Show_Details
    },

    toggleAssetDetails(asset) {
      const assetIndex = this.activeAssets.indexOf(asset)

      if (assetIndex > -1) {
        this.activeAssets.splice(assetIndex, 1)
      } else {
        this.activeAssets.push(asset)
      }
    },

    toggleFacet(facet, e) {
      const facetsContainer = e.target.nextSibling,
        facetIndex = this.activeFacets.indexOf(facet.solrField)

      if (facetIndex > -1) {
        this.activeFacets.splice(facetIndex, 1)
        // this.$nextTick(() => Scrollbar.destroy(facetsContainer))
      } else {
        this.activeFacets.push(facet.solrField)
        // this.$nextTick(() => Scrollbar.init(facetsContainer, { damping: 0.7 }))
      }
    },

    toggleFacetValue(facetValue) {
      const facetValueIndex = this.getActiveFacetIndex(facetValue)

      if (facetValueIndex > -1) {
        this.activeFacetsValues.splice(facetValueIndex, 1)
      } else {
        this.activeFacetsValues.push(facetValue)
      }

      this.pagination.model.currentPage = 1

      this.search()
    },

    getActiveFacetIndex(facetValue) {
      return this.activeFacetsValues.findIndex(
        activeFacetValue => activeFacetValue.solrField === facetValue.solrField && activeFacetValue.title === facetValue.title
      )
    },

    getFacetValueKey(facetValue) {
      return `${facetValue.solrField}_${facetValue.title}`
    },

    getAssetDownloadLink(asset) {
      const locationOrigin =
          window.location.origin || window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : ''),
        fileName = new RegExp(`\\.${asset.FileType}$`, 'i').test(asset.Name) ? asset.Name : `${asset.Name}.${asset.FileType}`

      return `${locationOrigin}/api/marketing-materials/assets/${asset.Id}/download?fileName=${encodeURIComponent(fileName)}`
    },

    getProductName(asset) {
      return asset.ResoundProductName || asset.BeltoneProductName || asset.IntertonProductName || asset.ProductName || '-'
    },
    getProductLanguage(asset) {
        return asset.Languages.join() || asset.Language || '-'
    },

    displaySearchInAddressBar() {
      const filters = Object.entries(this.searchFilters)
        .map(([solrField, values]) => `${solrField}=${values.join()}`)
        .join('&')

      let hash = this.searchQuery || ''

      if (filters) {
        hash += `&${filters}`
      }

      if (window.history.replaceState) {
        window.history.replaceState(null, null, `#${hash}`)
      } else {
        window.location.hash = hash
      }
    },

    setPageSize(pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.model.currentPage = 1
      this.search()
    },

    clearFacetFilters(facet) {
      this.activeFacetsValues = facet ? this.activeFacetsValues.filter(activeFacetsValue => activeFacetsValue.solrField !== facet.solrField) : []
      this.search()
    },

    getActiveFacetFiltersCount(facet) {
      return this.activeFacetsValues.filter(activeFacetsValue => activeFacetsValue.solrField === facet.solrField).length
    },

    hasActiveFacetFilters(facet) {
      return this.activeFacetsValues.findIndex(activeFacetsValue => activeFacetsValue.solrField === facet.solrField) >= 0
    },

    setSorting(orderBy) {
      this.sorting.orderBy = orderBy
      this.search()
    },

    setAscendingSortOrder() {
      this.sorting.orderAscending = true
      this.search()
    },

    setDescendingSortOrder() {
      this.sorting.orderAscending = false
      this.search()
    },

    getLocalizedNumberText(number, text, defaultValue) {
      const localizedText = text || '',
        singularPluralRegex = /(\w+\|\w+)/,
        matches = localizedText.match(singularPluralRegex)

      return matches
        ? number === 1
          ? localizedText.replace(/\{0\}/, number).replace(singularPluralRegex, matches[0].split('|')[0])
          : localizedText.replace(/\{0\}/, number).replace(singularPluralRegex, matches[0].split('|')[1])
        : defaultValue
    },

    getClearActiveFiltersText(facet) {
      const filtersCount = this.getActiveFacetFiltersCount(facet)
      return this.getLocalizedNumberText(filtersCount, this.localization.Clear_Facet_Filters, `Clear ${filtersCount} filter(s)`)
    }
  }
}
</script>
